import cloneDeep from 'lodash/cloneDeep';

/**
 * 获取同时修改了两种语言的字体的新paragraphList
 * @param paragraphList
 * @param fontFamily
 * @returns {*}
 */
export function getParagraphListWithNewFont(paragraphList, fontFamily) {
    if (!fontFamily.ea && !fontFamily.latin) {
        return paragraphList;
    }
    return paragraphList.map((paraItem) => {
        const para = cloneDeep(paraItem);
        if (!para.endParaRPr) {
            para.endParaRPr = {};
        }
        if (!para.endParaRPr.fonts) {
            para.endParaRPr.fonts = {};
        }
        if (fontFamily.ea) {
            para.endParaRPr.fonts.ea = fontFamily.ea;
        }
        if (fontFamily.latin) {
            para.endParaRPr.fonts.latin = fontFamily.latin;
        }
        para.endParaRPr['raw-fonts'] = true;
        para.textRuns = para?.textRuns.map((run) => {
            const textRun = { ...run };
            if (!textRun.styles.fonts) {
                textRun.styles.fonts = {};
            }
            if (fontFamily.ea) {
                textRun.styles.fonts.ea = fontFamily.ea;
            }
            if (fontFamily.latin) {
                textRun.styles.fonts.latin = fontFamily.latin;
            }
            textRun.styles['raw-fonts'] = true;
            return textRun;
        });
        return para;
    });
}
